import { jsx } from "react/jsx-runtime";
import { ListItemButton as MUIListItemButton } from "@mui/material";
import { forwardRef } from "react";
const ListItemButtonInner = ({ ...restProps }, ref) => {
  return /* @__PURE__ */ jsx(
    MUIListItemButton,
    {
      ...restProps,
      ref
    }
  );
};
const ListItemButton = forwardRef(
  ListItemButtonInner
);
export {
  ListItemButton
};
